export default __webpack_public_path__ + "static/media/SWT0020.34I-21324_-15287_0.b464bd93.jpg";